import styled from '@emotion/styled';
import { IntlProvider } from '@ory/elements';
import '@ory/elements/style.css';

import { useState } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { useMount } from 'react-use';

import { initAuth } from '@revelio/auth';

import { environment } from '../environment';
import { RedirectContext } from '../redirect-context';
import { RouterProvider, routes } from '../router';
import { SurfContext } from '../surf-context';
import { isWilsonBrand, wilsonFavicon } from '../wilson-brand';
import { ToastProvider } from './components/ui/toast';

initAuth({
  oryKratosRoot: environment.PUBLIC_ORY_KRATOS_URL,
});

// Build the router only AFTER initAuth: createBrowserRouter().initialize() runs
// the matched route's loader synchronously, and /personalize's loader
// dereferences the Ory client that initAuth creates. Router before init = a
// null client and an unhandled crash on a cold load of /personalize.
const router = createBrowserRouter(routes);

if (isWilsonBrand && typeof document !== 'undefined') {
  const favicon = document.querySelector(
    'link[rel="icon"]'
  ) as HTMLLinkElement | null;
  if (favicon) {
    favicon.type = 'image/svg+xml';
    favicon.href = wilsonFavicon;
  }
  const appleTouchIcon = document.querySelector(
    'link[rel="apple-touch-icon"]'
  ) as HTMLLinkElement | null;
  if (appleTouchIcon) {
    appleTouchIcon.href = wilsonFavicon;
  }
  document.title = 'Wilson Analytics Account';
}

const StyledApp = styled.div`
  height: 100%;
`;

function App() {
  const [redirect, setRedirect] = useState('');

  const [csrfState, setCsrf] = useState('');
  useMount(async () => {
    const surf = await fetch(`${environment.PUBLIC_USER_MGMT_URL}/surf`, {
      credentials: 'include',
    }).then((r) => r.json());
    if (surf?.csrfToken) {
      setCsrf(surf.csrfToken);
    }
  });

  return (
    <StyledApp>
      <IntlProvider locale="en">
        <RedirectContext.Provider value={[redirect, setRedirect]}>
          <SurfContext.Provider value={csrfState}>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </SurfContext.Provider>
        </RedirectContext.Provider>
      </IntlProvider>
    </StyledApp>
  );
}

export default App;
